import styled from "styled-components";
import { typography } from "src/theme";
import { colors } from "src/theme/colors";
import device from "src/constants/media";

export const CheckboxesWrapper = styled.div`
  display: block;
  max-width: 250px;
  gap: 12px;

  @media (min-width: 501px) {
    display: flex;
    max-width: 576px;
    flex-wrap: wrap;
  }
`;
export const InputWrapper = styled.div`
  border: 1px solid ${colors.greyLight};
  box-sizing: border-box;
  border-radius: 8px;
  display: flex;
  align-items: center;
`;

export const Textarea = styled.textarea`
  width: 100%;
  height: 76px;
  border-radius: 8px;
  resize: none;
  border: none;
  box-sizing: border-box;
  backdrop-filter: blur(27.1828px);
  outline: none;
  font-family: ${typography.fontFamily};
  font-style: normal;
  font-weight: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 28px;
  color: ${colors.greyDark};
  padding: 10px;

  :disabled {
    background-color: ${colors.greyVeryLight};
  }
`;
